import { z } from 'zod';
import { ZodProperties } from '../../../zod';
import {
  IMeasureDisplayFormatInput,
  MeasureDisplayFormatKind,
  MeasureDisplayFormatOperator,
} from '../../../apollo/graphqlSchema';

export const measureDisplayFormatSchema = z.object<
  ZodProperties<IMeasureDisplayFormatInput>
>({
  calculationUnit: z.nativeEnum(MeasureDisplayFormatOperator).nullable(),
  calculationValue: z.number().nullable(),
  decimalPlace: z.number().nullable(),
  kind: z.nativeEnum(MeasureDisplayFormatKind).nullable(),
  unit: z.string().nullable(),
});
